import { Buffer } from 'buffer';
import join from 'lodash/join';
import map from 'lodash/map';
import { getValue } from './commons';
var getNaturalValue = function getNaturalValue(value) {
  var pattern = /0*([0-9]+)|([^0-9]+)/g;
  var items = [];
  var item = pattern.exec(value);
  while (item) {
    items.push(item);
    item = pattern.exec(value);
  }
  var result = join(map(items, function (item) {
    return item[2] ? item[2] : "".concat(String(item[1].length).length).concat(item[1].length).concat(item[1]);
  }), '');
  return Buffer.from(result, 'utf8').toString('hex');
};
export var naturalSort = function naturalSort(pa, pb) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    insensitive: true,
    reverse: false
  };
  var a = pa && opts.insensitive ? pa.toLowerCase() : pa || '';
  var b = pb && opts.insensitive ? pb.toLowerCase() : pb || '';

  // Ensure the empty string is always last
  if (!a && !b) return 0;else if (!a && b) return 1;else if (a && !b) return -1;else if (opts.reverse === true) return getNaturalValue(b).localeCompare(getNaturalValue(a));else return getNaturalValue(a).localeCompare(getNaturalValue(b));
};
export var naturalCompare = function naturalCompare(a, b) {
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    insensitive: true,
    reverse: false
  };
  return naturalSort(getValue(a, field, ''), getValue(b, field, ''), opts);
};